import { useEffect } from 'react'
import { useRouter } from 'next/router'

export const useReferral = () => {
  const router = useRouter()

  useEffect(() => {
    if (!router.isReady) return

    const ref = router.query.ref as string | undefined
    if (ref) {
      localStorage.setItem('referral', ref)
    }
  }, [router.isReady, router.query.ref])
} 